import script from "./MoreResultsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoreResultsButton.vue?vue&type=script&setup=true&lang=ts"

import "./MoreResultsButton.vue?vue&type=style&index=0&id=14a6447a&lang=css"

const __exports__ = script;

export default __exports__